<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/account/socialaccount")
          i.far.fa-address-card
          span.ml-1 {{ $t("ui.social_account") }}
      b-breadcrumb-item(v-if="editSelectedAccountId && pageLvl != 'list' && getAccountType == 3")
        i.fa.fa-user
        span.ml-1 {{ editSelectedAccountId }}
  div.row
    div.col-md-12
      div.card
        div.card-header(v-if="getAccountType == 3 && pageLvl == 'list'")
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')")
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getOperatorList(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div(v-if="getAccountType == 3 && pageLvl == 'list'")
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
            div.row.clusterize
              div.col-md-12
                .clusterize-scroll
                  table.tablex(style="width: 100%;")
                    thead
                      tr
                        th.sticky-position(width="3%")
                          span #
                        th.sticky-position.sortable(width="10%" @click="sortOrder('account_id', 'opr')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          i(:class="changeSortKey('account_id', 'opr')")
                        th.sticky-position.sortable(width="10%" @click="sortOrder('profile_id', 'opr')")
                          span(:title="$t('ui.profile_id')") {{ $t('ui.profile_id') }}
                          i(:class="changeSortKey('profile_id', 'opr')")
                        th.sticky-position.sortable(width="16%" @click="sortOrder('full_name', 'opr')")
                          span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                          i(:class="changeSortKey('full_name', 'opr')")
                        th.sticky-position(width="11%")
                          span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                        th.sticky-position(width="15%")
                          span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                        th.sticky-position(width="7%")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        th.text-center.sticky-position(width="7%")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                        th.text-right.sticky-position.sortable(width="13%" @click="sortOrder('created_date', 'opr')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          i(:class="changeSortKey('created_date', 'opr')")
                    tbody.clusterize-content
                      tr(v-if="filteredOperatorList.length == 0")
                        td(colspan="9").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in filteredOperatorList" :class="$helpers.rowClass(item)")
                        td
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        //- td
                        //-   span.font-weight-bold.text-info
                        //-     b-link.text-info(href="javascript:void(0);" @click="getResultDetail()" :title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="item.profile_id") {{ item.profile_id }}
                        td
                          span(:title="item.full_name") {{ item.full_name }}
                        td
                          span(:title="item.contact_phone") {{ item.contact_phone }}
                        td
                          span(:title="item.last_login_ip") {{ item.last_login_ip }}
                        td
                          span(:title="item.status") {{ item.status }}
                        td.actions
                          span
                            a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEditSocialAccount(item)" :title="$t('ui.edit')")
                        td.text-right
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
          div(v-if="(getAccountType == 2 || editSelectedAccountId) && pageLvl == 'detail'")
            div.mb-1(v-if="getAccountType == 3 && pageLvl == 'detail'")
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="backToOperatorList"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
            div.row
              div.col-md-12.mb-3
                div.form-row
                  div.col-md-3.mb-1.mr-1
                    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
                      DebounceInput(
                        size="sm"
                        ref="accountId"
                        type="text"
                        v-model="socialDetail.account_id"
                        :disabled="loading"
                      )
            div.row
              div.col-md-12.mb-3
                div.form-row
                  div.col-md-6.mb-1.mr-2
                    table.tablex.mb-3
                      thead
                        tr
                          th
                            span {{ $t("ui.name") }}
                          th
                            span {{ $t("ui.account") }}
                      tbody
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.wechat") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="wechat"
                              type="text"
                              v-model="socialDetail.wechat"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.skype") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="skype"
                              type="text"
                              v-model="socialDetail.skype"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.line") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="line"
                              type="text"
                              v-model="socialDetail.line"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.telegram") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="telegram"
                              type="text"
                              v-model="socialDetail.telegram"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.whatsapp") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="whatsapp"
                              type="text"
                              v-model="socialDetail.whatsapp"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.facebook") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="facebook"
                              type="text"
                              v-model="socialDetail.facebook"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.instagram") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="instagram"
                              type="text"
                              v-model="socialDetail.instagram"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.tiktok") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="tiktok"
                              type="text"
                              v-model="socialDetail.tiktok"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.qq") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="qq"
                              type="text"
                              v-model="socialDetail.qq"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.twitter") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="twitter"
                              type="text"
                              v-model="socialDetail.twitter"
                              :disabled="loading"
                            )
                        tr
                          td
                            span.font-weight-bold.text-uppercase {{ $t("ui.viber") }}
                          td
                            DebounceInput(
                              size="sm"
                              ref="viber"
                              type="text"
                              v-model="socialDetail.viber"
                              :disabled="loading"
                            )
                        //- tr
                        //-   td
                        //-     span.font-weight-bold.text-uppercase {{ $t("ui.future1") }}
                        //-   td
                        //-     DebounceInput(
                        //-       size="sm"
                        //-       ref="future1"
                        //-       type="text"
                        //-       v-model="socialDetail.future1"
                        //-       :disabled="loading"
                        //-     )
                        //- tr
                        //-   td
                        //-     span.font-weight-bold.text-uppercase {{ $t("ui.future2") }}
                        //-   td
                        //-     DebounceInput(
                        //-       size="sm"
                        //-       ref="future2"
                        //-       type="text"
                        //-       v-model="socialDetail.future2"
                        //-       :disabled="loading"
                        //-     )
                        //- tr
                        //-   td
                        //-     span.font-weight-bold.text-uppercase {{ $t("ui.future3") }}
                        //-   td
                        //-     DebounceInput(
                        //-       size="sm"
                        //-       ref="future3"
                        //-       type="text"
                        //-       v-model="socialDetail.future3"
                        //-       :disabled="loading"
                        //-     )
            div.row
              div.col-md-12.mb-3
                div.form-row
                  div.col-md-6.mb-1.mr-2
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-save"
                      :text="$t('ui.save')"
                      type="button"
                      @click="saveAccountSocial"
                      variant="primary"
                      size="sm"
                      ).mb-1.mr-1
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { required, minLength, maxLength, alphaNum, integer, email, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult
  },
  data: () => ({
    loading: false,
    operatorList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    oprSortKey: "account_id",
    oprSortType: "asc",
    socialDetail: {
      account_id: '',
      wechat: '',
      skype: '',
      line: '',
      telegram: '',
      whatsapp: '',
      facebook: '',
      instagram: '',
      tiktok: '',
      qq: '',
      twitter: '',
      viber: '',
      future1: '',
      future2: '',
      future3: ''
    },
    editSelectedAccountId: null,
    pageLvl: "list"
  }),
  computed: {
    getAccountId() {
      return this.$store.getters.accountId;
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    getAccountType() {
      if (this.$store.getters.account[0])
        return this.$store.getters.account[0].account_type;

      return 0;
    },
    filteredOperatorList() {
      return this.operatorList.filter(function(obj) {
        return obj.self_operate == false;
      })
    },
  },
  mounted: function() {
    // var CryptoJS = require("crypto-js");
    // console.log(CryptoJS.MD5("/get/statusepic1445566").toString());

    if(this.$store.getters.account[0].account_type) {
      if (this.$store.getters.account[0].account_type == 2) {
        this.editSelectedAccountId = this.$store.getters.accountId;
        this.pageLvl = 'detail';
        this.getAccountSocialList();
      } else if (this.$store.getters.account[0].account_type == 3) {
        this.getOperatorList(true);
      }
    }
  },
  methods: {
    // getResultDetail(e) {
    //   // var url = 'http://localhost:52826/result.aspx?login_id=mymymymy008&auth_token=2ef8a6645787fdc7559285f408878843&result_id=476050' //member site live
    //   // var url = 'http://localhost:52826/result.aspx?login_id=kmkmkmkm001&auth_token=4a5356562f6358ba784962dd554fd99f&result_id=115' // member site uat
    //   var url = 'http://localhost:60995/result.aspx?account_id=vpvpvpvp&login_id=vpvpvpvp&profile_id=vpvpvpvp&auth_token=ded149747254da99aff2b47105b7fced&result_id=110'
    //   // var url = 'http://localhost:61828/result.aspx?account_id=mymymymy008&login_id=mymymymy008&profile_id=mymymymy008&auth_token=eafc0ff71aa24646f9200c52151bf1a6&result_id=457793' // agent site live
    //   // var url = 'http://localhost:62939/result.aspx?user_id=mini&function_id=gameresultdetail&page_id=report&token=0DDF708E1BE947EFBF0F27D8116CFE1F&result_id=458096'
    //   //var url = 'http://localhost:61409/result.aspx?user_id=michelle&function_id=gameresultdetail&page_id=report&token=DFE21426C7164B8896E9881597C0079F&result_id=120'
    //   window.open(url, "info", "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=680,height=640");
    // },
    sortOrder(key, type) {
      if (type == 'opr') {
        if (this.oprSortKey == key)
          this.oprSortType = this.oprSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.oprSortKey = key;
          this.oprSortType = 'asc';
        }

        this.getOperatorList(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'opr') {
        if (this.oprSortKey != key)
          return 'fas fa-sort';
        else if (this.oprSortKey == key && this.oprSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.oprSortKey == key && this.oprSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    backToOperatorList() {
      this.pageLvl = "list";
      this.socialDetail = null;
    },
    saveAccountSocial() {
      let url = config.accountSocialUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.socialDetail.account_id,
        wechat: this.socialDetail.wechat == '' ? null : this.socialDetail.wechat,
        skype: this.socialDetail.skype == '' ? null : this.socialDetail.skype,
        line: this.socialDetail.line == '' ? null : this.socialDetail.line,
        telegram: this.socialDetail.telegram == '' ? null : this.socialDetail.telegram,
        whatsapp: this.socialDetail.whatsapp == '' ? null : this.socialDetail.whatsapp,
        facebook: this.socialDetail.facebook == '' ? null : this.socialDetail.facebook,
        instagram: this.socialDetail.instagram == '' ? null : this.socialDetail.instagram,
        tiktok: this.socialDetail.tiktok == '' ? null : this.socialDetail.tiktok,
        qq: this.socialDetail.qq == '' ? null : this.socialDetail.qq,
        twitter: this.socialDetail.twitter == '' ? null : this.socialDetail.twitter,
        viber: this.socialDetail.viber == '' ? null : this.socialDetail.viber,
        // future1: this.socialDetail.future1 == '' ? null : this.socialDetail.future1,
        // future2: this.socialDetail.future2 == '' ? null : this.socialDetail.future2,
        // future3: this.socialDetail.future3 == '' ? null : this.socialDetail.future3
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.social_account"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onEditSocialAccount(e) {
      this.editSelectedAccountId = e.account_id;
      this.getAccountSocialList();
    },
    getOperatorList: function(isSearch) {
      let url = config.accountListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sort_key: this.oprSortKey,
        sort_type: this.oprSortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.search_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorList = response.data.dt;
                this.totalRow = this.operatorList.length > 0 ? this.operatorList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getAccountSocialList: function() {
      let url = config.accountSocialListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.editSelectedAccountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (response.data.dt.length > 0) {
                  this.pageLvl = 'detail';
                  this.socialDetail = response.data.dt[0];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getOperatorList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getOperatorList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>